import { render, staticRenderFns } from "./ConfirmArchivePopup.vue?vue&type=template&id=e4a3b9a2&scoped=true"
import script from "./ConfirmArchivePopup.vue?vue&type=script&lang=ts"
export * from "./ConfirmArchivePopup.vue?vue&type=script&lang=ts"
import style0 from "./ConfirmArchivePopup.vue?vue&type=style&index=0&id=e4a3b9a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4a3b9a2",
  null
  
)

export default component.exports